import React from 'react';
import { AccountBox } from '@material-ui/icons';
import Account from './Account';
import { routePaths } from '../../routePaths';
import { translate } from '../../utils';

const AccountRoute = {
    exact: false,
    path: routePaths.account,
    title: translate('Account'),
    icon: AccountBox,
    component: () => <Account />,
};

export default AccountRoute;
